import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

//bank
export const getAllActiveBanksDetails = async (clientId) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/banks/get",
      { clientId: clientId }
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const deleteBanksDetails = async (bankId) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/banks/delete",
      { bankId: bankId }
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const saveBanksDetails = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/banks/save",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const uploadFile = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "multipart/form-data",
      serviceHost + "/kyc/banks/uploadFile",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const saveUploadFile = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "multipart/form-data",
      serviceHost + "/kyc/banks/saveUploadFile",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const deleteFile = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/banks/deleteFile",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getContactList = async (clientId) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/contacts/getContactList",
      { clientId: clientId }
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const saveContact = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/contacts/saveContact",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const deleteContact = async (id) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/contacts/deleteContact",
      { id: id }
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const saveClient = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/client",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      let errClient = err;
      return { responseClient: null, errClient };
    }
  }
};

export const saveClientDepartment = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/userdepartment",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      let errClient = err;
      return { responseClient: null, errClient };
    }
  }
};

export const saveTDSDetails = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/tdsDetails",
      data
    );
    let responseTds = response;
    return { responseTds, errTds: null };
  } catch (err) {
    if (err) {
      let errTds = err;
      return { responseTds: null, errTds };
    }
  }
};
export const saveCustomerType = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/customerType",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const getClientInfo = async (clientId) => {
  try {
    let data = { clientId: clientId };
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/getactiveclient",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const saveFileUpload = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/fileUpload",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const getCustomerMisc = async (clientId) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/getCustomerMisc",
      { clientId: clientId }
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const saveCustomerMisc = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/saveCustomerMisc",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getContactsForCSV = async (clientId) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/contacts/getContactsForCSV/" + clientId
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getBanksForCSV = async (clientId) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/banks/getBanksForCSV/" + clientId
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const isExsistLookup = async (lookupCode) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/contacts/isExsistLookup",
      { lookupCode: lookupCode }
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getKycStatus = async (userId) => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/kyc/getKycStatus/" + userId
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const saveKycStatus = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/saveKycStatus/",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const deleteCustFile = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "multipart/form-data",
      serviceHost + "/client/deleteFile",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const checkBeforeApprove = async (clientId, isSupplier) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/checkBeforeApprove",
      { clientId: clientId, isSupplier: isSupplier }
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
